<img-with-fallback [src]="$node()?.imageUrl || null" class="w-100 h-100">
	<div class="w-100 h-100 fl fl-ai-c fl-jc-c" [class.bg-node-type]="$useNodeColor()">
		@if ($node(); as node) {
			@if (node.emoji) {
				{{ node.emoji }}
			} @else {
				<i [nodeTypeIcon]="node.nodeType"></i>
			}
		}
	</div>
</img-with-fallback>
